/**
 * Email client. /generate produces an AI draft (never sends); /send sends
 * immediately via Mailgun after the human reviewed it in the dialog.
 */

import { request } from './api';

export interface Recipient {
  name?: string;
  email: string;
}

export interface GeneratedDraft {
  subject: string;
  body: string;
  suggestedRecipients: Recipient[];
  from: string;
}

export interface SentEmail {
  id: string;
  createdAt: string;
  leadId?: string;
  to: string;
  subject: string;
  body: string;
  status: string;
  sentAt?: string;
}

interface ListResponse<T> {
  items: T[];
  total: number;
}

export const emailsApi = {
  generate: (leadId: string) =>
    request<GeneratedDraft>('/api/emails/generate', {
      method: 'POST',
      body: JSON.stringify({ leadId }),
    }),
  send: (input: {
    leadId?: string;
    to: string[];
    subject: string;
    body: string;
    questions?: string[];
  }) =>
    request<{ ok: true; providerMessageId: string }>('/api/emails/send', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  list: (status = 'sent') =>
    request<ListResponse<SentEmail>>(`/api/emails?status=${encodeURIComponent(status)}`),
};
